export default __webpack_public_path__ + "static/media/Burgundy-and-Red-Wrap-Bracelet.41336a7f.jpg";